import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-menu',
    standalone: true,
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss',
    imports: [
        CommonModule,
        RouterLink,
        MatToolbarModule,
        MatListModule,
        MatIconModule,
        MatExpansionModule
    ]
})
export class MenuComponent {

    panelOpenState = false;

    loading = false;

    /*
    constructor(public rpt: ReportService) {

        this.rpt.loading$.subscribe((x: undefined | boolean) => {
            if (x == true) {
                this.loading = true;
            } else {
                this.loading = false;
            }
        });

    }
        */

}
